module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("老师管理")]), _vm._v(" "), _c('Breadcrumb-item', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.goFolder(0)
      }
    }
  }, [_vm._v("外教中心展示资料")])]), _vm._v(" "), _vm._l((_vm.folderTrail), function(item, idx) {
    return _c('Breadcrumb-item', {
      key: 'f' + item.id
    }, [(idx < _vm.folderTrail.length - 1) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.goFolder(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _c('span', [_vm._v(_vm._s(item.title))])])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 80,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "标题："
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.title),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "title", $$v)
      },
      expression: "queryParam.title"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "状态："
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 12,
      "sm": 8,
      "md": 6
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "default",
      "icon": "folder"
    },
    on: {
      "click": function($event) {
        return _vm.openFolderModal()
      }
    }
  }, [_vm._v("新建文件夹")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/tchLearningMaterial/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.editingFolder ? '编辑文件夹' : (_vm.formData.id ? '编辑资料' : '新增资料'),
      "width": "640",
      "mask-closable": false
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('Form', {
    ref: "editForm",
    attrs: {
      "label-width": 100,
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  })], 1), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "文件",
      "prop": "fileUrl"
    }
  }, [_c('FileUpload', {
    attrs: {
      "defaultFileList": _vm.defaultFileList,
      "num": 1,
      "text": "点击或拖拽上传资料"
    },
    on: {
      "on-file-change": _vm.onFileChange
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "可见范围",
      "prop": "visibleType"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.visibleType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "visibleType", $$v)
      },
      expression: "formData.visibleType"
    }
  }, [_c('Radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部老师")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("欧美外教")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("菲教")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("中教")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("指定老师")])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder && _vm.formData.visibleType === 1) ? _c('FormItem', {
    attrs: {
      "label": "指定老师",
      "prop": "tchIds"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "请选择外教"
    },
    model: {
      value: (_vm.formData.tchIds),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchIds", $$v)
      },
      expression: "formData.tchIds"
    }
  }, _vm._l((_vm.tchList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.firstName) + " " + _vm._s(item.lastName))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "有效天数"
    }
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "min": 0,
      "max": 3650
    },
    model: {
      value: (_vm.formData.effectDays),
      callback: function($$v) {
        _vm.$set(_vm.formData, "effectDays", $$v)
      },
      expression: "formData.effectDays"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999"
    }
  }, [_vm._v("0 或空表示长期有效")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editingFolder) ? _c('FormItem', {
    attrs: {
      "label": "首页弹窗"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#999",
      "line-height": "20px",
      "margin-bottom": "8px"
    }
  }, [_vm._v("不添加周期时，老师确认一次后不再提示")]), _vm._v(" "), _vm._l((_vm.formData.popupPeriods), function(period, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-bottom": "8px"
      }
    }, [_c('DatePicker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "type": "date",
        "format": "yyyy-MM-dd",
        "placeholder": "开始日期"
      },
      model: {
        value: (period.startDate),
        callback: function($$v) {
          _vm.$set(period, "startDate", $$v)
        },
        expression: "period.startDate"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin": "0 4px"
      }
    }, [_vm._v("至")]), _vm._v(" "), _c('DatePicker', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "type": "date",
        "format": "yyyy-MM-dd",
        "placeholder": "结束日期"
      },
      model: {
        value: (period.endDate),
        callback: function($$v) {
          _vm.$set(period, "endDate", $$v)
        },
        expression: "period.endDate"
      }
    }), _vm._v(" "), _c('Select', {
      staticStyle: {
        "width": "90px",
        "margin-left": "6px"
      },
      model: {
        value: (period.freq),
        callback: function($$v) {
          _vm.$set(period, "freq", $$v)
        },
        expression: "period.freq"
      }
    }, [_c('Option', {
      attrs: {
        "value": 1
      }
    }, [_vm._v("每天")]), _vm._v(" "), _c('Option', {
      attrs: {
        "value": 2
      }
    }, [_vm._v("每周")])], 1), _vm._v(" "), _c('Button', {
      staticStyle: {
        "margin-left": "4px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removePopupPeriod(index)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.addPopupPeriod
    }
  }, [_vm._v("添加周期")])], 2) : _vm._e(), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", $$v)
      },
      expression: "formData.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "新建文件夹",
      "width": "420",
      "mask-closable": false
    },
    model: {
      value: (_vm.showFolderModal),
      callback: function($$v) {
        _vm.showFolderModal = $$v
      },
      expression: "showFolderModal"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 100
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "文件夹名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入文件夹名称"
    },
    model: {
      value: (_vm.folderForm.title),
      callback: function($$v) {
        _vm.$set(_vm.folderForm, "title", $$v)
      },
      expression: "folderForm.title"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "160px"
    },
    model: {
      value: (_vm.folderForm.status),
      callback: function($$v) {
        _vm.$set(_vm.folderForm, "status", $$v)
      },
      expression: "folderForm.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("停用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.showFolderModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.folderSaving
    },
    on: {
      "click": _vm.onSaveFolder
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "预览",
      "width": "960",
      "footer-hide": ""
    },
    model: {
      value: (_vm.previewVisible),
      callback: function($$v) {
        _vm.previewVisible = $$v
      },
      expression: "previewVisible"
    }
  }, [_c('FilePreview', {
    attrs: {
      "file-url": _vm.previewUrl,
      "type": _vm.previewType,
      "file-name": _vm.previewFileName
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e405c3c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/TchLearningMaterialList.vue
// module id = 1818
// module chunks = 8